export const DEFAULT_THEME_NAME = 'Default';
export const DEFAULT_THEME_DESCRIPTION =
  'The default theme uses the default theme and branding for the site. This means that all Form content is displayed as the designer intended.';
